// HubSpot shopping info form, prefilled with the customer and designer so the
// shopping team can pick the project up without asking for them again.
// `project.customer` is the shape Design::ProjectSerializer#customer_info returns.
const shoppingInfoFormUrl = (project, user) => {
  const params = {
    // URLSearchParams spells a missing value "null", which HubSpot then prefills.
    firstname: project.customer.first_name || '',
    lastname: project.customer.last_name || '',
    email: project.customer.email || '',
    returning_client_: project.customer.returning_customer ? 'Yes' : 'No',
    mulit_room_client_: project.customer.multiroom_customer ? 'Yes' : 'No',
    timestamp: Date.now(),
    mbr_designer_name: user.full_name,
    mbr_design_url: `https://www.mybespokeroom.com/design/projects/${project.id}`,
  };

  const baseUrl = 'https://share.hsforms.com/1IUFlC7O9S-uiQVN6Kk00Fg2r5wv';
  const queryString = new URLSearchParams(params).toString();
  return `${baseUrl}?${queryString}`;
};

export default shoppingInfoFormUrl;



// WEBPACK FOOTER //
// ./app/javascript/common/utils/shoppingInfoForm.js